import { graphql } from "~/gql";

export const FEE_EARNERS_BY_LEVEL_QUERY = graphql(/* GraphQL */ `
  query FeeEarnersByLevel($feeEarnerLevelId: Int!) {
    feeEarnersByLevel(feeEarnerLevelId: $feeEarnerLevelId) {
      id
      name
    }
  }
`);
